
import { Component, Vue } from 'vue-property-decorator'

/**
 * ボタンの基底コンポーネント
 */
@Component
export default class ButtonBase extends Vue {
  /**
   * クリックイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private clickEvent(event: Event): void {
    this.$emit('click', event)
  }
}
